import PropTypes from 'prop-types';
import { TrashIcon } from '@heroicons/react/24/outline';
import AlertDialog from '../core/AlertDialog';

const DeleteConfigurationDialog = ({ show, configName, isDeleting, onCancel, onDelete }) => (
  <AlertDialog
    show={show}
    icon={
      <div className="bg-red-100 p-2 rounded-full">
        <TrashIcon className="w-6 h-6 text-red-600" />
      </div>
    }
    title="Delete configuration"
    onClose={!isDeleting ? onCancel : undefined}
    actions={
      <>
        <button onClick={onCancel} disabled={isDeleting} className="btn btn-sm btn-outline">
          Cancel
        </button>
        <button
          onClick={onDelete}
          disabled={isDeleting}
          className="btn btn-sm bg-red-500 hover:bg-red-600 text-white border-none"
        >
          {isDeleting ? <span className="loading loading-spinner loading-sm"></span> : 'Delete'}
        </button>
      </>
    }
  >
    <p>Are you sure you want to delete the configuration &quot;{configName}&quot;? This cannot be undone.</p>
  </AlertDialog>
);

DeleteConfigurationDialog.propTypes = {
  show: PropTypes.bool.isRequired,
  configName: PropTypes.string,
  isDeleting: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default DeleteConfigurationDialog;
